import React from 'react';
import GameGrid from './GameGrid';
import RoadmapPanel from './RoadmapPanel';
import { Support, TwitchPanel } from './CalloutPanel';
import PlaytestRoster from './Plytestroster';
import DevelopersSection from './developers';
import GameplayPanel from './GameplayPanel';
import gameplayVideo from "../Assets/ehgvids/combat1.mp4";
import gameplayVideo2 from "../Assets/ehgvids/combat2.mp4";
import gameplayVideo3 from "../Assets/ehgvids/combat3.mp4";

import News from './News';
//import gameplayVideo2 from "../Assets/ehgvids/anothercombat.mp4";
//import gameplayVideo3 from "../Assets/ehgvids/bossfight.mp4";

/*  description={"Epic Hero game is a physics-based roguelite Game. Build your own superhero and fight off against an alien invasion on the world. Defend the fully destructible map using a variety of skills, moves and abilities."}
-              link={steam}
-              video={"https://www.youtube.com/embed/ias3KT3sFRE"}
-              title={"Epic Hero Game"}
-              tags={["Early Access", "Roguelite", "Physics-Based", "Superhero", "Action"]}*/
const news = [
  {
    id: "7",
    title: "New boss, new skills, new map",
    description: `
- **Blackmage**, a three-headed skeleton boss
- **New skills** like Giant Form, Shadow Clone and Ki Hands
- **Throw anything**: trees, props and knocked-out enemies
- **Planet map**: travel between planets in space
`,
    category: "In development",
    date: "Oct 2026",
    featured: true,
  },

  {
    id: "6",
    title: "Save slots and planet travel",
    description:
      "Three save slots, and you can fly between planets as a comet and land anywhere.",
    category: "In development",
    date: "Oct 20, 2026",
    featured: false,
  },

  {
    id: "5",
    title: "Patch 0.61: Engine upgrade",
    description:
      "Moved to Unity 6.3, and the terrain now dents without massive explosions.",
    category: "Update",
    date: "Sep 17, 2026",
    link: "https://store.steampowered.com/news/app/3190600/view/1844115010491600",
    featured: false,
  },

  {
    id: "4",
    title: "Patch 0.6: More planets",
    description:
      "More than one playable planet, and Ronnie is the new first boss.",
    category: "Update",
    date: "Aug 30, 2026",
    link: "https://store.steampowered.com/news/app/3190600/view/1842212951307274",
    featured: false,
  },
];
const games = [
  {
    id: 'main',
    title: "Epic Hero Game",
    description: "Epic Hero game is a physics-based roguelite Game. Build your own superhero and fight off against an alien invasion on the world. Defend the fully destructible map using a variety of skills, moves and abilities."
    ,
    video: "https://www.youtube.com/embed/ias3KT3sFRE",
    image: '',
    link: 'https://store.steampowered.com/app/2081720/Epic_Hero_Game/',
    tags: ['Early Access', 'Roguelite', 'Physics-Based', 'Superhero', 'Action'],
    featured: true,
  },
];

const games2 = [
  {
    id: 'main',
    title: "Epic Hero Game",
    description: "Epic Hero game is a physics-based roguelite Game. Build your own superhero and fight off against an alien invasion on the world. Defend the fully destructible map using a variety of skills, moves and abilities."
    ,
    video: [
      gameplayVideo,
      gameplayVideo2,
      gameplayVideo3
    ],
    image: '',
    link: 'https://store.steampowered.com/app/2081720/Epic_Hero_Game/',
    tags: ['Early Access', 'Roguelite', 'Physics-Based', 'Superhero', 'Action'],
    featured: true,
  },
];

/* Next up at the top, oldest shipped at the bottom.
   State as of the Nov 4, 2026 game design doc. */
const milestones = [
  { status: 'Pending', text: 'Early access on Steam' },
  { status: 'Pending', text: 'Rewards that carry over between runs' },
  { status: 'Pending', text: 'Loot that matches each stage' },
  { status: 'In-Progress', text: 'Build your own ultimate combo' },
  { status: 'Completed', text: 'Moon floors with keys, locks and fog' },
  { status: 'Completed', text: 'Galaxy run: islands, moons, planets' },
  { status: 'Completed', text: 'Item crafting trees and shops' },
  { status: 'Completed', text: 'Physics engine upgrade' },
  { status: 'Completed', text: 'Initial prototype finished' },
];

const Home = ({ kofi, twitchChannel }) => (
  <>
    {
      /*<GameGrid title="Our games" games={games} meta="1 in early access" />
*/}
    <GameplayPanel game={games2[0]}></GameplayPanel>
    <section className="section section--raised">
      <div className="container">
        <News news={news}></News>
      </div>
    </section>
    <section className="section section--raised">
      <div className="container">

        <div className="home-aside">
          <RoadmapPanel milestones={milestones} title="Roadmap" />

          <div className="callout-row">
            <PlaytestRoster taken={133}></PlaytestRoster>
            <Support link={kofi} />
            <TwitchPanel channelName={twitchChannel} />
          </div>

        </div>
        <DevelopersSection></DevelopersSection>

      </div>
    </section>
  </>
);

export default Home;